__webpack_require__.p = "/join-hives/_next/";